import { LitElement, html } from "lit";

import type { DirectiveClass, DirectiveResult } from "lit/async-directive.js";
import { customElement, property, state } from "lit/decorators.js";

import { styles } from "./page-content.css";

import type { TranslationKey } from "../../translations/i18n";
import "../page-header/page-header";

@customElement("page-content")
export class PageContent extends LitElement {
  static override styles = styles;

  @property()
  pageTitle: TranslationKey | DirectiveResult<DirectiveClass> = "";

  @state()
  private hasBackground = false;

  private handleBackgroundSlotChange = (e: Event) => {
    const slot = e.target as HTMLSlotElement;
    const assignedNodes = slot.assignedNodes();
    this.hasBackground = assignedNodes.length > 0;
  };

  override render() {
    return html`
      <page-header title=${this.pageTitle} class="${this.hasBackground ? "has-background" : ""}">
        <slot name="background" slot="background" @slotchange=${this.handleBackgroundSlotChange}></slot>
        <slot name="title" slot="title"></slot>
        <slot name="actions"></slot>
      </page-header>
      <main><slot></slot></main>
    `;
  }
}
